// JavaScript source code
import React, { useEffect, useState } from 'react';
import {  useParams } from 'react-router-dom';
import dataSubBanner from '../assets/fake-data/data-subbanner';
import Header from '../components/header';
import SubFooter from '../components/subfooter';
import { getUser } from '../request';
import LoginDialog from '../components/loginDialog';

function FinancialService(props) {
    let activeIndex = 4;
    let activeSubIndex = 3;
    const theData = dataSubBanner.filter(item => {
        return item.id == activeSubIndex;
    })[0];
    const [screenSize, setScreenSize] = useState(window.innerWidth);
    const [isShowLogin, setIsShowLogin] = useState(false);
    var user = getUser();
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    useEffect(() => {
        const handleResize = () => {
            setScreenSize(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (      
        <div className={`aboutUs ${theData.titleClass}`} >
            <Header activeIndex={activeIndex} user={user} setIsShowLogin={setIsShowLogin}/>
            <div className="content">
                <div className="pageHead">
                    <div className="pageTitle">{theData.pageTitle}</div>
                    <div className="pageSubTitle">{theData.pageSubTitle}</div>
                    <div className="pageDetail">{theData.pageDetail}</div>
                </div>
                <div className="subcontent">
                    {
                        screenSize > 991 ? (
                            <div>                            {
                            theData.imgList.map((item, index) => (
                                <img key={index} src={item} />
                            ))
                            }
                            </div>) :
                    (
                            <div>
                                   
                                    {
                                        theData.mimgList.map((img, index) => (
                                            <img  src={img} />
                                        ))
                                    }
                            </div>
                    )

                }
                </div>
            </div>
            <SubFooter />
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />
        </div>
          
    );
}

export default FinancialService;